import React from 'react';
import { arrayOf, string } from 'prop-types';
import {
  params,
  shape,
  string as stringType,
  extend,
  QueryProvider,
  useDataModel,
  arrayOf as arrayType,
} from '@thd-nucleus/data-sources';
import { ProductPod } from '@thd-olt-component-react/product-pod';
import { Row } from '@thd-olt-component-react/core-ui';
import styles from './tools-materials.module.scss';

export const FirstCall = ({ itemIds, storeId }) => {
  const {
    data,
    loading,
  } = useDataModel('searchModel', {
    variables: { itemIds, storeId },
  });

  if (loading) {
    return <div className={styles.placeholder} />;
  }

  const productData = data?.searchModel?.products || [];

  return productData.map((products, index) => {
    return (
      <div
        style={{ paddingTop: '10px', paddingBottom: '30px', borderBottom: '3px solid #F5F5F5' }}
        key={`related-products-${index}`}
      >
        <Row key={`related-products-${index}`}>
          <QueryProvider
            cacheKey="search-product-pods"
            defaultVariables={{ storeId: '121' }}
            dataSource="searchNav"
          >
            <ProductPod
              miniOptions={{
                onAction: () => {},
                enableATC: true,
                hideCaret: true,
              }}
              dataSource="searchNav"
              storeId={storeId}
              itemId={products?.itemId}
              podType="mini"
              showKPF={false}
              isHDQCSku
              onHeaderClick={(event) => {
                event.preventDefault();
              }}
            />
          </QueryProvider>
        </Row>
      </div>
    );
  });
};

FirstCall.propTypes = {
  itemIds: arrayOf(string).isRequired,
  storeId: string.isRequired
};

const product = extend({}, ProductPod.dataModel.product);
FirstCall.dataModel = {
  searchModel: params({
    itemIds: arrayType(stringType()).isRequired(),
    storeId: stringType(),
  }).shape({
    products: arrayType(shape(product)),
  }),
};
